import CountUp from 'countup.js'

const Counter = () => {
  const handlers = document.querySelectorAll('.js-counter')
  const waypoints = []

  if (!handlers || !handlers.length) return

  ;[...handlers].forEach((element) => {
    waypoints.push(new window.Waypoint.Inview({
      element,
      offset: 'bottom-in-view',
      enter: function () {
        this.element.classList.add('active')
        let counters = [].slice.call(document.querySelectorAll('.js-counter-value'))
        if (counters) {
          counters.forEach((index) => {
            window.setTimeout(() => {
              if (!index.classList.contains('active')) {
                let animate = new CountUp(index, 0, index.dataset.value)
                animate.start()
                index.classList.add('active')
              }
            }, 300)
          })
        }
      }
    }))
  })
}

export default Counter



// WEBPACK FOOTER //
// ./src/js/modules/Counter.js